export enum ReminderType {
    ReminderAppointment = 'ReminderAppointment',
    ReminderPayment = 'ReminderPayment',
    ReminderVaccination = 'ReminderVaccination',
    ReminderParasiticide = 'ReminderParasiticide',
    ReminderPreOperation = 'ReminderPreOperation',
    ReminderPostOperation = 'ReminderPostOperation',
    ReminderHealthCarePlan = 'ReminderHealthCarePlan',
}